import React from "react";
import { toggle } from "../../../util/common";
import { useTranslation } from "react-i18next";

import { IAddressInformation } from "../../../store/credit/types";
interface IProps {
    data?: IAddressInformation[];
}
const CreditHistoryAddressInfo: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    let col = null;
    if (props.data != null) {
        col = props.data;
    }

    return (
        <React.Fragment>
            <div className="drawer-container">
                <div className="drawer-header">
                    <button
                        aria-expanded="false"
                        className="btn-default btn-toggle btn-drawer"
                        id="btn-address-information"
                        onClick={() => toggle("address-information", "btn-address-information")}
                    >
                        <span className="btn-toggle-status sr-only">Show</span>
                        <span className="btn-text">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.addressInformationSection.title")}</span>
                    </button>
                </div>

                <div className="drawer-content" id="address-information" style={{ display: "none" }}>
                    {col != null ? (
                        <div className="table-container scroll">
                            <table className="m-table-generic">
                                <caption className="sr-only">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.addressInformationSection.titleInfo")}</caption>
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            <span className="sr-only">Item</span>
                                        </th>
                                        {col.map((addressInfo: IAddressInformation) => (
                                            <th key={addressInfo.bureau + "_addressInfoBureau"} scope="col">
                                                {addressInfo.bureau}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row" className="table-label">
                                            {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.addressInformationSection.address")}
                                        </th>
                                        {col.map((addressInfo: IAddressInformation) => (
                                            <td key={addressInfo.bureau + addressInfo.order + "_addressInfo"}>{addressInfo.address}</td>
                                        ))}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default CreditHistoryAddressInfo;
